/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_ThrottledInputs */

const fr_api_throttled = /** @type {(inputs: Api_ThrottledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop de demandes. Patientez un instant, puis réessayez.`)
};

const en_api_throttled = /** @type {(inputs: Api_ThrottledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many requests. Wait a moment, then try again.`)
};

/**
* | output |
* | --- |
* | "Too many requests. Wait a moment, then try again." |
*
* @param {Api_ThrottledInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_throttled = /** @type {((inputs?: Api_ThrottledInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_ThrottledInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_throttled(inputs)
	return fr_api_throttled(inputs)
});